import React, { useState } from "react";
import { BsEye, BsEyeSlash } from "react-icons/bs";

/**
 * Password input with a show/hide toggle.
 * Spreads any input props (value, onChange, placeholder, name, required, autoComplete...).
 */
export default function PasswordInput({ className = "pf-input", ...props }) {
  const [show, setShow] = useState(false);
  return (
    <div className="pf-pw">
      <input {...props} type={show ? "text" : "password"} className={className} />
      <button
        type="button"
        className="pf-pw-toggle"
        onClick={() => setShow((s) => !s)}
        aria-label={show ? "Hide password" : "Show password"}
        title={show ? "Hide password" : "Show password"}
        tabIndex={-1}
      >
        {show ? <BsEyeSlash /> : <BsEye />}
      </button>
    </div>
  );
}
